// VideoshoppingRelativeProduct.js
;(function () {
  if (!window.videoshoppingRelativeProduct) {
    class VideoshoppingRelativeProduct extends Player.Plugin {
      static get pluginName() {
        return 'videoshoppingRelativeProduct'
      }

      static get defaultConfig() {
        const { POSITIONS } = Player.Plugin
        return {
          position: POSITIONS.CONTROLS_RIGHT
        }
      }

      static mobileProductListdrawer = null
      static productDetailDrawer = null
      static currentDisplayedProduct = null
      /**
       * @type {object} couponCode
       * @property {string} couponCode.code 优惠码
       * @property {string} couponCode.value_type 优惠码
       * @property {number} couponCode.value 优惠码
       */
      static couponCode = null
      /**
       * @type {boolean} couponCodeLoading
       */
      static couponCodeLoading = false

      static swiper = null

      static reported = false
      static reporting = false

      constructor(args) {
        super(args)
      }

      async getCouponCode() {
        try {
          this.couponCodeLoading = true
          const baseURL =
            window.Shopify.theme.role === 'development'
              ? 'https://10245wefa1141.vicp.fun/'
              : 'https://shopify-api.melodysusie.com/'
          const fetchUrl = baseURL + 'api/video-hub/discount-code'
          const response = await fetch(fetchUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
          const data = await response.json()
          this.couponCode = data.data
          this.couponCodeLoading = false
          return this.couponCode
        } catch (error) {
          console.error('getCouponCode error', error)
          return null
        } finally {
          this.couponCodeLoading = false
        }
      }

      getCouponCodeDescription(couponCode) {
        if (!couponCode) {
          return ''
        }
        let no = 1
        let htmlText = ''
        if (couponCode.prerequisite_subtotal_range) {
          htmlText += `<p>${no}. Minimum purchase of ${couponCode.prerequisite_subtotal_range} USD required.</p>`
          no++
        }
        if (couponCode.prerequisite_quantity_range) {
          htmlText += `<p>${no}. Minimum ${couponCode.prerequisite_quantity_range} items per order.</p>`
          no++
        }
        if (typeof couponCode.usage_limit === 'number') {
          let combineText = ''
          if (couponCode.usage_limit > 0) {
            combineText = `Limit of ${couponCode.usage_limit} uses, `
          }
          if (couponCode.once_per_customer) {
            combineText += 'one per customer'
          }
          htmlText += `<p>${no}. ${combineText}</p>`
          no++
        } else {
          if (couponCode.once_per_customer) {
            htmlText += `<p>${no}. One use per customer</p>`
          } else {
            htmlText += `<p>${no}. No usage limits</p>`
          }
          no++
        }
        if (couponCode.product_discount_type) {
          if (couponCode.product_discount_type === 'all') {
            htmlText += `<p>${no}. Valid on all items.</p>`
          } else {
            htmlText += `<p>${no}. Valid on selected items only.</p>`
          }
          no++
        }
        return htmlText
      }

      afterCreate() {
        this.icon = this.find('.icon')
        this.onClick = () => {
          // 调用显示Drawer的方法
          this.showDrawer()
          this.queryCouponCodeAndUpdateCoupon()
        }
        this.on(Player.Events.TIME_UPDATE, () => this.onPalyerTimeupdate())
        this.bind('click', this.onClick)
      }

      /**
       * 查询优惠码并更新优惠码
       */
      async queryCouponCodeAndUpdateCoupon() {
        const couponCode = await this.getCouponCode()
        const mobileCouponSec = document.querySelector('.video-shopping-drawer .drawer-coupon-section')
        const pcCouponSec = document.querySelector('.product-and-coupon-section .coupon-section')
        if (couponCode) {
          // 手机端
          if (window.matchMedia('(max-width: 1024px)').matches) {
            mobileCouponSec && mobileCouponSec.classList.remove('hidden')
            const couponDiscountEle = mobileCouponSec && mobileCouponSec.querySelector('.drawer-coupon-discount')
            if (couponDiscountEle) {
              if (couponCode.value_type === 'percentage') {
                couponDiscountEle.textContent = `${couponCode.value * 100}% OFF`
              } else {
                couponDiscountEle.textContent = `$${couponCode.value} OFF`
              }
            }
            const couponCodeEle = mobileCouponSec && mobileCouponSec.querySelector('.drawer-coupon-code')
            if (couponCodeEle) {
              couponCodeEle.textContent = `${couponCode.code}`
            }
            const couponCodeRuleDesc =
              mobileCouponSec && mobileCouponSec.querySelector('.drawer-coupon-code-rule-description')
            if (couponCodeRuleDesc) {
              couponCodeRuleDesc.innerHTML = this.getCouponCodeDescription(couponCode)
            }
            // pc端
          } else {
            pcCouponSec && pcCouponSec.classList.remove('hidden')
            const couponDiscountEle = pcCouponSec && pcCouponSec.querySelector('.coupon-discount')
            if (couponDiscountEle) {
              if (couponCode.value_type === 'percentage') {
                couponDiscountEle.textContent = `${couponCode.value * 100}% OFF`
              } else {
                couponDiscountEle.textContent = `$${couponCode.value} OFF`
              }
            }
            const couponCodeEle = pcCouponSec && pcCouponSec.querySelector('.coupon-code')
            const couponCodeRuleDesc = pcCouponSec && pcCouponSec.querySelector('.coupon-code-rule-description')
            if (couponCodeEle) {
              couponCodeEle.textContent = `${couponCode.code}`
            }
            if (couponCodeRuleDesc) {
              couponCodeRuleDesc.innerHTML = this.getCouponCodeDescription(couponCode)
            }
          }
        } else {
          if (window.matchMedia('(max-width: 1024px)').matches) {
            if (mobileCouponSec) {
              if (!mobileCouponSec.classList.contains('hidden')) {
                mobileCouponSec.classList.add('hidden')
              }
            }
          } else {
            if (pcCouponSec) {
              if (!pcCouponSec.classList.contains('hidden')) {
                pcCouponSec.classList.add('hidden')
              }
            }
          }
        }
      }

      async insertProductData(productList, modalProduct) {
        const products = this.player.products
        // 手机端逻辑,如果有多个产品，只显示第一个产品，且在视频上方播放的产品增加一个More
        if (window.matchMedia('(max-width: 1024px)').matches) {
          // 只显示第一个产品
          const firstProduct = products[0]
          if (firstProduct) {
            const productItem = document.createElement('div')
            productItem.className = 'product-item'
            productItem.innerHTML = `
                    <img src="${firstProduct.image}&width=800" alt="${firstProduct.name}" class="product-image">
                    <div class="video-shopping-product-info">
                      <div>
                        <div class="product-name">${firstProduct.name}</div>
                        <div class="product-variant">${firstProduct.variant}</div>
                      </div>
                      <div class="product-price-container">
                        <div class="product-price">$${firstProduct.price}</div>
                        <div class="product-original-price ${
                          firstProduct.originalPrice && firstProduct.price < firstProduct.originalPrice ? '' : 'hidden'
                        }">$${firstProduct.originalPrice}</div>
                      </div>
                    </div>
                  `
            productList.appendChild(productItem)
          }
          if (products.length > 1) {
            // 添加More按钮
            const moreButton = document.createElement('button')
            moreButton.className = 'more-products-btn'
            moreButton.textContent = 'More'
            productList.appendChild(moreButton)

            // 处理More按钮点击事件
            moreButton.addEventListener('click', () => {
              // 展示所有产品
              this.showDrawer()
            })
          }
        } else {
          // 电脑端逻辑
          if (this.player.products.length === 0) {
            return
          }
          const productAndCouponSection = document.createElement('div')
          productAndCouponSection.className = 'product-and-coupon-section'
          productAndCouponSection.innerHTML = `
          <div class="products-header-sec">
            <div class="products-title">Related Products</div>
            <div class="drawer-cart-info">
              <span class="cart-icon">
                <svg role="presentation" stroke-width="1.5" focusable="false" width="22" height="22" class="icon icon-cart" viewBox="0 0 22 22">
                  <path d="M11 7H3.577A2 2 0 0 0 1.64 9.497l2.051 8A2 2 0 0 0 5.63 19H16.37a2 2 0 0 0 1.937-1.503l2.052-8A2 2 0 0 0 18.422 7H11Zm0 0V1" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
                <span class="cart-count">0</span>
              </span>
            </div>
          </div>
          <div class="coupon-section">
            <div class="coupon-discount">0% OFF</div>
            <div class="coupon-divider"></div>
            <div class="coupon-code"></div>
            <div class="coupon-code-rule">
              <span>?</span>
              <div class="coupon-code-rule-content">
                <div class="coupon-code-rule-title">Discount Rules</div>
                <div class="coupon-code-rule-description"></div>
              </div>
            </div>
            <div class="coupon-divider"></div>
            <button class="copy-button">COPY</button>
          </div>
          `
          setTimeout(async () => {
            await this.updateCartItemCount()
          })
          const couponExit = modalProduct.querySelector('.product-and-coupon-section')
          if (!couponExit) {
            modalProduct.insertBefore(productAndCouponSection, productList)
          }
          products.forEach((product) => {
            const productItem = document.createElement('div')
            productItem.className = 'product-item'
            productItem.innerHTML = `
                    <img src="${product.image}&width=800" alt="${product.name}" class="product-image">
                    <div class="video-shopping-product-info">
                      <div>
                        <div class="product-name">${product.name}</div>
                        <div class="product-variant">${product.variant}</div>
                      </div>
                      <div class="product-price-container">
                        <div class="product-price">$${product.price}</div>
                        <div class="product-original-price ${
                          product.originalPrice && product.price < product.originalPrice ? '' : 'hidden'
                        }">$${product.originalPrice}</div>
                        <a class="view-more-button" data-product-id="${
                          product.variant_id || Math.random().toString(36).substr(2, 9)
                        }">
                          View More
                        </a>
                      </div>
                    </div>
                  `
            const itemWrapper = document.createElement('div')
            itemWrapper.appendChild(productItem)
            itemWrapper.className = 'product-item-wrapper'
            if (product.timeRange && typeof product.timeRange.start === 'number') {
              itemWrapper.innerHTML += ` 
                    <div class="product-controls">
                      <div class="product-controls-left">
                        <button class="highlight-button" data-start-time="${product.timeRange.start}" data-end-time="${product.timeRange.end}">
                          <svg t="1742281735049" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1499" width="16" height="16"><path d="M817.088 484.96l-512-323.744C295.232 154.976 282.752 154.592 272.576 160.224 262.336 165.856 256 176.608 256 188.256l0 647.328c0 11.648 6.336 22.4 16.576 28.032 4.8 2.656 10.112 3.968 15.424 3.968 5.952 0 11.904-1.664 17.088-4.928l512-323.616C826.368 533.184 832 522.976 832 512 832 501.024 826.368 490.816 817.088 484.96z" fill="#ffffff" p-id="1500"></path></svg>
                          Highlight
                        </button>
                      </div>
                      <div class="product-controls-right">
                        <div class="quantity-control">
                          <button class="decrease-quantity">-</button>
                          <input type="number" class="quantity-input" value="1" min="1" style="width: 30px; text-align: center;">
                          <button class="increase-quantity">+</button>
                        </div>
                        <button class="add-to-cart-button">Add to Cart</button>
                      </div>
                    </div>
                    `
            } else {
              itemWrapper.innerHTML += `
                    <div class="product-controls">
                      <span class="product-controls-left">
                        &nbsp;
                      </span>
                      <div class="product-controls-right">
                        <div class="quantity-control">
                          <button class="decrease-quantity">-</button>
                          <input type="number" class="quantity-input" value="1" min="1" style="width: 30px; text-align: center;">
                          <button class="increase-quantity">+</button>
                        </div>
                        <button class="add-to-cart-button">Add to Cart</button>
                      </div>
                    </div>
                    `
            }

            productList.appendChild(itemWrapper)
            // 绑定事件逻辑
            this.bindProductControls(itemWrapper, product)
          })
          const copyButton = modalProduct.querySelector('.copy-button')
          if (copyButton) {
            copyButton.addEventListener('click', () => {
              this.copyCouponCode(copyButton)
            })
          }

          const cartButton = productAndCouponSection.querySelector('.drawer-cart-info .cart-icon')
          cartButton &&
            cartButton.addEventListener('click', () => {
              // 点击打开购物车
              const themeCartIconEle = document.querySelector('.header__secondary-nav .tdf_cart_icon')
              if (themeCartIconEle) {
                themeCartIconEle.click()
              }
            })
        }
        if (modalProduct) {
          const videoModalXgPlayerDom = document.querySelector('#videoModal .xgplayer')
          if (modalProduct.parentNode && videoModalXgPlayerDom) {
            modalProduct.parentNode.style.height = videoModalXgPlayerDom.clientHeight + 'px'
          }
        }

        // 监听整个站点的购物车数量变化
        document.addEventListener('cart:change', () => {
          this.updateCartItemCount()
        })
      }

      bindProductControls(itemWrapper, product) {
        const highlightButton = itemWrapper.querySelector('.highlight-button')
        const viewMoreButton = itemWrapper.querySelector('.view-more-button')

        if (highlightButton) {
          highlightButton.addEventListener('click', () => {
            this.highlightProduct(product.timeRange.start)
            if (this.mobileProductListdrawer) {
              this.mobileProductListdrawer.classList.remove('active')
              setTimeout(() => {
                document.body.removeChild(this.mobileProductListdrawer)
                this.mobileProductListdrawer = null
              }, 300)
            }
          })
        }

        const quantityInput = itemWrapper.querySelector('.quantity-input')
        const decreaseButton = itemWrapper.querySelector('.decrease-quantity')
        const increaseButton = itemWrapper.querySelector('.increase-quantity')
        if (quantityInput) {
          decreaseButton &&
            decreaseButton.addEventListener('click', () => {
              let quantity = parseInt(quantityInput.value)
              if (quantity > 1) {
                quantityInput.value = --quantity
              }
            })

          increaseButton &&
            increaseButton.addEventListener('click', () => {
              let quantity = parseInt(quantityInput.value)
              quantityInput.value = ++quantity
            })
        }

        const addToCartButton = itemWrapper.querySelector('.add-to-cart-button')
        if (addToCartButton) {
          addToCartButton.addEventListener('click', async () => {
            const quantity = parseInt(quantityInput.value)
            if (addToCartButton.classList.contains('disabled')) {
              return
            }
            addToCartButton.classList.add('disabled')
            addToCartButton.textContent = 'Adding...'
            const success = await this.addToCart({
              product,
              quantity,
              variantId: product.variant_id
            })
            if (success) {
              await this.updateCartItemCount()
              setTimeout(() => {
                addToCartButton.classList.remove('disabled')
                addToCartButton.textContent = 'Add to Cart'
              }, 200)
            }
          })
        }

        if (viewMoreButton) {
          viewMoreButton.addEventListener('click', async () => {
            if (viewMoreButton.classList.contains('disabled')) {
              return
            }
            viewMoreButton.classList.add('disabled')
            viewMoreButton.textContent = 'Loading...'
            const success = await this.showProductDetail(product)
            if (success) {
              viewMoreButton.classList.remove('disabled')
              viewMoreButton.textContent = 'View More'
            } else {
              viewMoreButton.classList.remove('disabled')
              viewMoreButton.textContent = 'Load Failed'
            }
          })
        }
      }

      async showProductDetail(product) {
        // 创建商品详情弹窗
        if (this.productDetailDrawer) {
          document.body.removeChild(this.productDetailDrawer)
        }

        // 通过公开接口获取产品详情。
        let publicProductData = await this.queryShopifyProductByHandle(product.handle)
        if (!publicProductData) {
          return false
        }
        const drawer = document.createElement('div')
        this.productDetailDrawer = drawer
        drawer.className = 'product-detail-drawer'
        drawer.style =
          '--swiper-navigation-top-offset: 50%; --swiper-navigation-color: #ffffff; --swiper-navigation-size: 20px; --swiper-navigation-sides-offset: 20px;--swiper-pagination-color: #ef8c8c;'

        // 模拟商品的多个图片
        const productImages = publicProductData.images

        // 变体数据
        const variants = publicProductData.variants.map((variant) => {
          return {
            id: variant.id,
            variant_id: variant.id,
            title: variant.title,
            image: variant.featured_image ? variant.featured_image.src : '',
            available: variant.available,
            price: variant.price / 100,
            originalPrice: variant.compare_at_price / 100
          }
        })

        drawer.innerHTML = `
          <div class="product-detail-content">
            <div class="drawer-header">
              <button class="close-drawer">
                <svg t="1742453012536" width="20" height="20" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19926" width="64" height="64"><path d="M297.813333 491.648l1.365334-1.749333 379.093333-376.149334a38.784 38.784 0 0 1 5.077333-4.096 34.346667 34.346667 0 0 1 14.293334-4.992c2.218667-0.170667 2.176-0.170667 4.394666-0.170666a33.493333 33.493333 0 0 1 14.549334 4.181333c12.330667 6.997333 18.688 21.76 15.274666 35.498667-1.237333 5.077333-7.04 13.44-7.04 13.44l-355.498666 352.853333 354.090666 354.389333s6.272 7.978667 7.893334 12.928a32.213333 32.213333 0 0 1-33.749334 41.557334c-6.656-0.682667-17.749333-7.68-17.749333-7.68l-379.221333-377.984-1.28-1.450667a30.378667 30.378667 0 0 1-7.893334-17.749333 31.018667 31.018667 0 0 1 3.712-18.602667 27.221333 27.221333 0 0 1 2.688-4.224z" p-id="19927" fill="#ffffff"></path></svg>
              </button>
            </div>
            
            <div class="product-gallery swiper">
              <div class="swiper-wrapper">
                ${productImages
                  .map(
                    (img) => `
                  <div class="swiper-slide">
                    <img src="${img}" alt="${product.name}" />
                  </div>
                `
                  )
                  .join('')}
              </div>
              <div class="swiper-pagination"></div>
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
            </div>
    
            <div class="video-shopping-product-info-section">
              <h2 class="product-title">${product.name}</h2>
              <div class="product-price-section">
                <span class="current-price">$${product.price}</span>
                <span class="original-price ${
                  product.originalPrice && product.price < product.originalPrice ? '' : 'hidden'
                }">$${product.originalPrice}</span>
              </div>
              <div class="variant-section ${variants.length === 1 ? 'hidden' : ''}">
                <h3 class="variant-title">Color: <span class="selected-variant"></span></h3>
                <div class="variant-options">
                  ${variants
                    .map(
                      (variant) => `
                      <img class="variant-option ${variant.available ? '' : 'disabled'}" 
                        data-variant-id="${variant.id}"
                        src="${variant.image}&width=200"
                        ${variant.available ? '' : 'disabled'} 
                        alt="${variant.title}"
                        loading="lazy"
                      >
                    `
                    )
                    .join('')}
                </div>
              </div>
              <div class="product-description">
                <h3>Product Description</h3>
                <div>${publicProductData.description}</div>
              </div>
            </div>
    
            <div class="product-detail-footer">
              <div class="quantity-control">
                <button class="decrease-quantity">-</button>
                <input type="number" class="quantity-input" value="1" min="1">
                <button class="increase-quantity">+</button>
              </div>
              <button class="add-to-cart-button">Add to Cart</button>
            </div>
          </div>
        `

        document.body.appendChild(drawer)

        // 初始化 Swiper
        this.swiper = new Swiper(drawer.querySelector('.product-gallery'), {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoHeight: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        })

        // 绑定事件
        const closeButton = drawer.querySelector('.close-drawer')
        closeButton.addEventListener('click', () => {
          drawer.classList.remove('active')
          setTimeout(() => {
            document.body.removeChild(drawer)
            this.productDetailDrawer = null
          }, 300)
        })

        // 变体选择
        const variantImages = drawer.querySelectorAll('.variant-option')
        variantImages.forEach((img) => {
          img.addEventListener('click', () => {
            variantImages.forEach((btn) => btn.classList.remove('selected'))
            img.classList.add('selected')
            const selectedVariant = img.dataset.variantId
            const selectedVariantInfo = variants.find((variant) => variant.id.toString() === selectedVariant)
            if (selectedVariantInfo) {
              // 更新价格和图片
              const currentPriceElement = drawer.querySelector('.current-price')
              const originalPriceElement = drawer.querySelector('.original-price')
              if (currentPriceElement) {
                currentPriceElement.textContent = '$' + selectedVariantInfo.price
              }
              if (originalPriceElement) {
                originalPriceElement.textContent = '$' + selectedVariantInfo.originalPrice
              }

              if (selectedVariantInfo.price >= selectedVariantInfo.originalPrice) {
                if (!originalPriceElement.classList.contains('hidden')) {
                  originalPriceElement.classList.add('hidden')
                }
              } else {
                if (originalPriceElement.classList.contains('hidden')) {
                  originalPriceElement.classList.remove('hidden')
                }
              }

              if (this.swiper) {
                const swiperImgIndex = productImages.findIndex((img) => img === selectedVariantInfo.image.slice(6))
                if (swiperImgIndex !== -1) {
                  this.swiper.slideTo(swiperImgIndex)
                }
              }

              drawer.querySelector('.selected-variant').textContent = selectedVariantInfo.title
            }
          })
        })

        if (variantImages.length > 0) {
          // 默认点击第一个变体数据
          variantImages[0].click()
        }

        // 数量控制
        const quantityInput = drawer.querySelector('.quantity-input')
        const decreaseButton = drawer.querySelector('.decrease-quantity')
        const increaseButton = drawer.querySelector('.increase-quantity')

        decreaseButton.addEventListener('click', () => {
          let quantity = parseInt(quantityInput.value)
          if (quantity > 1) {
            quantityInput.value = --quantity
          }
        })

        increaseButton.addEventListener('click', () => {
          let quantity = parseInt(quantityInput.value)
          quantityInput.value = ++quantity
        })

        // Add to Cart
        const addToCartButton = drawer.querySelector('.add-to-cart-button')
        addToCartButton.addEventListener('click', async () => {
          const quantity = parseInt(quantityInput.value)
          const selectedVariant = drawer.querySelector('.variant-option.selected')
          const variantId = selectedVariant ? selectedVariant.dataset.variantId : null
          if (!variantId) {
            alert('Please select a variant')
            return
          }
          if (addToCartButton.classList.contains('disabled')) {
            return
          }
          addToCartButton.classList.add('disabled')
          addToCartButton.textContent = 'Adding...'
          const success = await this.addToCart({
            product,
            quantity,
            variantId
          })
          if (success) {
            await this.updateCartItemCount()
            setTimeout(() => {
              addToCartButton.classList.remove('disabled')
              addToCartButton.textContent = 'Add to Cart'
            }, 200)
          }
        })

        // 显示弹窗
        setTimeout(() => {
          drawer.classList.add('active')
        }, 0)
        return true
      }

      // 监听视频播放时间更新事件
      async onPalyerTimeupdate() {
        let products = this.player.products
        // 手机平板
        if (window.matchMedia('(max-width: 1024px)').matches) {
          const currentTime = this.player.currentTime
          // 根据时间更新显示的产品
          const currentProduct = products.find((product, index) => {
            if (typeof product.timeRange.start === 'number') {
              // 假设每个产品有一个时间段属性
              if (Number(product.timeRange.end) === 0) {
                return currentTime >= product.timeRange.start
              } else if (Number(product.timeRange.end) !== 0) {
                return currentTime >= product.timeRange.start && currentTime < product.timeRange.end
              } else {
                return currentTime >= product.timeRange.start
              }
            } else {
              false
            }
          })
          if (currentProduct && currentProduct !== this.currentDisplayedProduct) {
            this.currentDisplayedProduct = currentProduct
            const videoModal = document.getElementById('videoModal')
            if (videoModal) {
              const productList = videoModal.querySelector('.product-list')
              this.updateProductList({ productList, currentProduct })
            }
          }
          if (this.mobileProductListdrawer) {
            const controlsBtnList = this.mobileProductListdrawer.querySelectorAll('.product-controls .highlight-button')
            controlsBtnList.forEach((controlsBtn) => {
              if (controlsBtn) {
                if (
                  Number(controlsBtn.dataset.endTime) !== 0 &&
                  this.player.currentTime > Number(controlsBtn.dataset.endTime)
                ) {
                  controlsBtn.innerHTML = `<svg t="1742281735049" width="16" height="16" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1499" width="64" height="64"><path d="M817.088 484.96l-512-323.744C295.232 154.976 282.752 154.592 272.576 160.224 262.336 165.856 256 176.608 256 188.256l0 647.328c0 11.648 6.336 22.4 16.576 28.032 4.8 2.656 10.112 3.968 15.424 3.968 5.952 0 11.904-1.664 17.088-4.928l512-323.616C826.368 533.184 832 522.976 832 512 832 501.024 826.368 490.816 817.088 484.96z" fill="#ffffff" p-id="1500"></path></svg>
                    Highlight`
                } else if (this.player.currentTime > Number(controlsBtn.dataset.startTime)) {
                  controlsBtn.innerHTML = `<svg t="1742281868816" width="16" height="16" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2599" width="64" height="64"><path d="M149.674667 405.482667v213.034666H106.666667v-213.034666h43.008z m128.149333-102.805334v418.645334h-43.626667V302.677333h43.626667z m127.893333 64v290.645334H362.453333V366.677333h43.242667zM534.357333 213.333333v597.333334h-42.496V213.333333h42.496z m127.936 153.344v290.645334h-43.136V366.677333h43.136z m127.893334-64v418.645334h-42.858667V302.677333h42.88z m127.957333 102.378667v213.333333H874.453333v-213.333333h43.669334z" p-id="2600" fill="#ffffff"></path></svg>Playing`
                } else {
                  controlsBtn.innerHTML = `<svg t="1742281735049" width="16" height="16" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1499" width="64" height="64"><path d="M817.088 484.96l-512-323.744C295.232 154.976 282.752 154.592 272.576 160.224 262.336 165.856 256 176.608 256 188.256l0 647.328c0 11.648 6.336 22.4 16.576 28.032 4.8 2.656 10.112 3.968 15.424 3.968 5.952 0 11.904-1.664 17.088-4.928l512-323.616C826.368 533.184 832 522.976 832 512 832 501.024 826.368 490.816 817.088 484.96z" fill="#ffffff" p-id="1500"></path></svg>
                    Highlight`
                }
              }
            })
          }
        } else {
          const videoModal = document.getElementById('videoModal')
          // 如果当前时间大于 product-wrapper-item内的商品的开始时间，则将该商品的highlight文本显示为Playing
          const controlsBtnList = videoModal.querySelectorAll('.product-controls .highlight-button')
          controlsBtnList.forEach((controlsBtn) => {
            if (controlsBtn) {
              if (
                Number(controlsBtn.dataset.endTime) !== 0 &&
                this.player.currentTime > Number(controlsBtn.dataset.endTime)
              ) {
                controlsBtn.innerHTML = `<svg t="1742281735049" width="16" height="16" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1499" width="64" height="64"><path d="M817.088 484.96l-512-323.744C295.232 154.976 282.752 154.592 272.576 160.224 262.336 165.856 256 176.608 256 188.256l0 647.328c0 11.648 6.336 22.4 16.576 28.032 4.8 2.656 10.112 3.968 15.424 3.968 5.952 0 11.904-1.664 17.088-4.928l512-323.616C826.368 533.184 832 522.976 832 512 832 501.024 826.368 490.816 817.088 484.96z" fill="#ffffff" p-id="1500"></path></svg>
                  Highlight`
              } else if (this.player.currentTime > Number(controlsBtn.dataset.startTime)) {
                controlsBtn.innerHTML = `<svg t="1742281868816" width="16" height="16" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2599" width="64" height="64"><path d="M149.674667 405.482667v213.034666H106.666667v-213.034666h43.008z m128.149333-102.805334v418.645334h-43.626667V302.677333h43.626667z m127.893333 64v290.645334H362.453333V366.677333h43.242667zM534.357333 213.333333v597.333334h-42.496V213.333333h42.496z m127.936 153.344v290.645334h-43.136V366.677333h43.136z m127.893334-64v418.645334h-42.858667V302.677333h42.88z m127.957333 102.378667v213.333333H874.453333v-213.333333h43.669334z" p-id="2600" fill="#ffffff"></path></svg>Playing`
              } else {
                controlsBtn.innerHTML = `<svg t="1742281735049" width="16" height="16" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1499" width="64" height="64"><path d="M817.088 484.96l-512-323.744C295.232 154.976 282.752 154.592 272.576 160.224 262.336 165.856 256 176.608 256 188.256l0 647.328c0 11.648 6.336 22.4 16.576 28.032 4.8 2.656 10.112 3.968 15.424 3.968 5.952 0 11.904-1.664 17.088-4.928l512-323.616C826.368 533.184 832 522.976 832 512 832 501.024 826.368 490.816 817.088 484.96z" fill="#ffffff" p-id="1500"></path></svg>
                  Highlight`
              }
            }
          })
        }
        if (this.player.currentTime > 5 && !this.reported) {
          if (this.reporting) {
            return
          }
          await this.reportVideoPlayCount()
        }
      }

      async reportVideoPlayCount() {
        try {
          this.reporting = true
          const baseURL =
            window.Shopify.theme.role === 'development'
              ? 'https://10245wefa1141.vicp.fun/'
              : 'https://shopify-api.melodysusie.com/'
          const fetchUrl = baseURL + 'api/video-hub/play-count-increase'
          const videoId = this.player.config.id.split('-').pop() && Number(this.player.config.id.split('-').pop())
          if (typeof videoId === 'number') {
            const response = await fetch(fetchUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                video_id: videoId,
                play_time: 5
              }),
              keepalive: true
            })
            if (!response.ok) {
              throw new Error('Network response was not ok')
            }
            const reportRes = await response.json()
            if (reportRes.status === 200) {
              this.reported = true
            } else {
              this.reported = false
            }
            this.reporting = false
          } else {
            this.reporting = false
            this.reported = false
          }
        } catch (error) {
          this.reporting = false
          this.reported = false
          console.error('Error reporting video play count:', error)
        }
      }

      /** 针对手机端的产品的监听随着视频播放时长变化更新产品 */
      updateProductList({ productList, currentProduct }) {
        productList.innerHTML = `
                <div class="product-item">
                  <img src="${currentProduct.image}&width=800" alt="${currentProduct.name}" class="product-image">
                  <div class="video-shopping-product-info">
                    <div>
                      <div class="product-name">${currentProduct.name}</div>
                      <div class="product-variant">${currentProduct.variant}</div>
                    </div>
                    <div class="product-price-container">
                      <div class="product-price">$${currentProduct.price}</div>
                      <div class="product-original-price ${
                        currentProduct.originalPrice && currentProduct.price < currentProduct.originalPrice
                          ? ''
                          : 'hidden'
                      }">$${currentProduct.originalPrice}</div>
    
                    </div>
                  </div>
                </div>
              `
        if (this.player.products.length > 1) {
          // 添加More按钮
          const moreButton = document.createElement('button')
          moreButton.className = 'more-products-btn'
          moreButton.textContent = 'More'
          productList && productList.appendChild(moreButton)

          // 处理More按钮点击事件
          moreButton.addEventListener('click', () => {
            // 展示所有产品
            this.showDrawer()
          })
        }
      }

      async showDrawer() {
        if (this.player.products.length === 0) {
          return
        }
        if (this.mobileProductListdrawer) {
          document.body.removeChild(this.mobileProductListdrawer)
        }

        const drawer = document.createElement('div')
        this.mobileProductListdrawer = drawer
        drawer.className = 'mobile-drawer drawer video-shopping-drawer'
        drawer.id = 'video-shopping-drawer'
        drawer.innerHTML = `
          <div class="drawer-content">
            <div class="drawer-header">
              <div class="drawer-title">
                <span>Related Products</span>
              </div>
              <div class="drawer-cart-info">
                <span class="cart-icon">
                  <svg role="presentation" stroke-width="1.5" focusable="false" width="22" height="22" class="icon icon-cart" viewBox="0 0 22 22">
                    <path d="M11 7H3.577A2 2 0 0 0 1.64 9.497l2.051 8A2 2 0 0 0 5.63 19H16.37a2 2 0 0 0 1.937-1.503l2.052-8A2 2 0 0 0 18.422 7H11Zm0 0V1" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  <span class="cart-count">0</span>
                </span>
                <button class="close-drawer">×</button>
              </div>
            </div>
            <div class="drawer-coupon-section hidden">
              <div class="drawer-coupon-discount">0% OFF</div>
              <div class="drawer-coupon-divider"></div>
              <div class="drawer-coupon-code"></div>
              <div class="drawer-coupon-code-rule">
                <span>?</span>
                <div class="drawer-coupon-code-rule-content">
                  <div class="drawer-coupon-code-rule-title">Discount Rules</div>
                  <div class="drawer-coupon-code-rule-description"></div>
                </div>
              </div>
              <div class="drawer-coupon-divider"></div>
              <button class="drawer-copy-button">COPY</button>
            </div>
            <div class="product-list" id="drawerProductList">
              <!-- 产品列表将由JavaScript动态填充 -->
            </div>
        </div>
        `
        document.body.appendChild(drawer)
        await this.updateCartItemCount()
        // 关闭Drawer的逻辑
        const closeButton = this.mobileProductListdrawer.querySelector('.close-drawer')
        const cartButton = this.mobileProductListdrawer.querySelector('.cart-icon')
        const copyButton = this.mobileProductListdrawer.querySelector('.drawer-copy-button')
        closeButton.addEventListener('click', () => {
          setTimeout(() => {
            document.body.removeChild(this.mobileProductListdrawer)
            this.mobileProductListdrawer = null
          }, 300)
        })
        copyButton.addEventListener('click', () => {
          this.copyCouponCode(copyButton)
        })

        cartButton &&
          cartButton.addEventListener('click', () => {
            // 点击打开购物车
            const themeCartIconEle = document.querySelector('.header__secondary-nav .tdf_cart_icon')
            if (themeCartIconEle) {
              themeCartIconEle.click()
            }
          })

        // 填充产品列表
        this.populateMobileDrawerProducts(this.player.products)
        setTimeout(() => {
          this.mobileProductListdrawer.classList.add('active')
        }, 0)
      }

      async queryShopifyProductByHandle(handle) {
        const response = await fetch(`/products/${handle}.js`)
        if (!response.ok) {
          return null
        }
        return await response.json()
      }

      populateMobileDrawerProducts(products) {
        const drawerProductList = document.getElementById('drawerProductList')
        products.forEach((product) => {
          const item = document.createElement('div')
          item.className = 'product-item'
          item.innerHTML = `
            <img src="${product.image}&width=800" alt="${product.name}" class="product-image">
            <div class="video-shopping-product-info">
              <div>
                <div class="product-name">${product.name}</div>
                <div class="product-variant">${product.variant}</div>
              </div>
              <div class="product-price-container">
                <div class="product-price">$${product.price}</div>
                <div class="product-original-price ${
                  product.originalPrice && product.price < product.originalPrice ? '' : 'hidden'
                }">$${product.originalPrice}</div>
                <a class="view-more-button" data-product-id="${
                  product.variant_id || Math.random().toString(36).substr(2, 9)
                }">View More</a>
              </div>
            </div>
          `
          const itemWrapper = document.createElement('div')
          itemWrapper.className = 'product-item-wrapper'
          itemWrapper.appendChild(item)
          if (product.timeRange && typeof product.timeRange.start === 'number') {
            itemWrapper.innerHTML += ` <div class="product-controls">
              <button class="highlight-button" data-start-time="${product.timeRange.start}" data-end-time="${product.timeRange.end}">
              <svg t="1742281735049" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1499" width="16" height="16"><path d="M817.088 484.96l-512-323.744C295.232 154.976 282.752 154.592 272.576 160.224 262.336 165.856 256 176.608 256 188.256l0 647.328c0 11.648 6.336 22.4 16.576 28.032 4.8 2.656 10.112 3.968 15.424 3.968 5.952 0 11.904-1.664 17.088-4.928l512-323.616C826.368 533.184 832 522.976 832 512 832 501.024 826.368 490.816 817.088 484.96z" fill="#ffffff" p-id="1500"></path></svg>
                Highlight
              </button>
              <div class="product-controls-right">
                <div class="quantity-control">
                  <button class="decrease-quantity">-</button>
                  <input type="number" class="quantity-input" value="1" min="1" style="width: 30px; text-align: center;">
                  <button class="increase-quantity">+</button>
                </div>
                <button class="add-to-cart-button">Add to Cart</button>
              </div>
           
            </div>
            `
          } else {
            itemWrapper.innerHTML += `<div class="product-controls">
              <span>&nbsp;</span>
              <div class="product-controls-right">
                <div class="quantity-control">
                  <button class="decrease-quantity">-</button>
                  <input type="number" class="quantity-input" value="1" min="1" style="width: 30px; text-align: center;">
                  <button class="increase-quantity">+</button>
                </div>
                <button class="add-to-cart-button">Add to Cart</button>
              </div>
            </div>
            `
          }
          drawerProductList.appendChild(itemWrapper)
          this.bindProductControls(itemWrapper, product)
        })
      }

      highlightProduct(startTime) {
        this.player.currentTime = startTime // 跳转到对应的开始时间
        this.player.play() // 播放视频
      }

      async addToCart({ product, quantity, variantId }) {
        const videoId = this.player.config.id.split('-').pop() && Number(this.player.config.id.split('-').pop())
        // 这里可以添加实际的购物车逻辑
        const item = {
          id: Number(variantId),
          quantity
        }
        if (videoId) {
          item.properties = {
            _from_video_shopping: videoId
          }
          if (product.aff_id) {
            item.properties._aff_id = product.aff_id
          }
        }
        const addToCartRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [item]
          })
        })
        if (addToCartRes.ok) {
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true
            })
          )
          return true
        } else {
          return false
        }
      }

      async updateCartItemCount() {
        // 这里可以添加实际的购物车逻辑
        const cartRes = await fetch('/cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })

        if (cartRes.ok) {
          const cartData = await cartRes.json()
          const cartCount = cartData.item_count
          // mobile cart count element
          const cartCountElement =
            this.mobileProductListdrawer && this.mobileProductListdrawer.querySelector('.cart-count')
          if (cartCountElement) {
            cartCountElement.textContent = cartCount
          }
          // pc cart count element
          const pcCartCountElement = document.querySelector('.video-shopping-drawer .cart-count')
          if (pcCartCountElement) {
            pcCartCountElement.textContent = cartCount
          }
        }
      }

      copyCouponCode(copyButton) {
        const couponCode = this.couponCode.code
        navigator.clipboard.writeText(couponCode).then(() => {
          copyButton.textContent = 'COPIED'
          copyButton.classList.add('copied')

          setTimeout(() => {
            copyButton.textContent = 'COPY'
            copyButton.classList.remove('copied')
          }, 2000)
        })
      }

      destroy() {
        this.unbind('click', this.onClick)
        this.off(Player.Events.TIME_UPDATE, () => this.onPalyerTimeupdate())
        this.icon = null
        this.swiper = null
        this.reported = false
      }

      render() {
        return `<div class="relative-product-plugin video-shopping-bag"><div class="icon">
        <svg t="1741771093828" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21857" width="64" height="64"><path d="M943.12 803.936L870.944 320H736v80h65.984L864 815.744a55.2 55.2 0 0 1-12.96 44.816A55.216 55.216 0 0 1 808.608 880H199.36a55.216 55.216 0 0 1-42.4-19.44A55.216 55.216 0 0 1 144 815.728L206.016 400H416V232c0-48.528 39.472-88 88-88s88 39.472 88 88V320h-112v80h192V232C672 139.36 596.64 64 504 64S336 139.36 336 232V320H137.056L64.88 803.936a135.904 135.904 0 0 0 31.488 108.848A135.888 135.888 0 0 0 199.376 960H808.64a135.888 135.888 0 0 0 103.008-47.2 135.888 135.888 0 0 0 31.488-108.864zM336 504a40 40 0 1 0 80 0 40 40 0 0 0-80 0z m256 0a40 40 0 1 0 80 0 40 40 0 0 0-80 0z" fill="#ffffff" p-id="21858"></path></svg>
        </div></div>`
      }
    }

    window.videoshoppingRelativeProduct = VideoshoppingRelativeProduct
  }
})()
